
import Switch from "react-switch";
import styles from "./Toggle.scss";

class Toggle extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange = (checked) => { this.props.handleChange(checked); }


    render() {
        return (

            <label className={this.props.rmMb?styles.scermMb:null} htmlFor={this.props.id}>

                <Switch
                    checked={this.props.isToggleOn}
                    onChange={this.handleChange}
                    handleDiameter={22}
                    height={this.props.height?this.props.height:30}
                    width={this.props.width?this.props.width:70}
                    borderRadius={15}
                    onColor={this.props.onColor?this.props.onColor:"#000000"}
                    offColor="#FFFFFF"
                    offHandleColor="#919191"
                    disabled={this.props.isDisabled ? this.props.isDisabled : false}
                    uncheckedIcon={<div className={styles.Off}>Off</div>}
                    checkedIcon={<div className={styles.On}>On</div>}
                    aria-checked={this.props.isToggleOn ? true : false}
                    className={this.props.isToggleOn ? "react-switch" : ["react-switch", styles.sceToggleOffBorder].join(" ")}
                    id={this.props.id}
                />

            </label>

        );
    }
}
export default Toggle;
